<template>
    <div @click="closeChatbot" :class="{ scrollLock: scrollLock }">
        <component
            :is="this.$route.meta.layout || 'div'"
            :dark="this.$route.meta.dark"
        >
            <router-view />
        </component>
        <cookie-law
            class="v-application"
            theme="jobstairs"
            storageType="cookies"
            v-on:accept="enableTracking"
        />
    </div>
</template>

<script>
import CookieLaw from 'vue-cookie-law';
import Chatbot from '@/store/types/Chatbot';
import JobboardService from '@/services/JobboardService';
import config from '@/config';

export default {
    name: 'App',
    components: {
        CookieLaw,
    },
    provide() {
        return {
            jobboardService: new JobboardService({
                ...config.search,
                request: {
                    properties: config.jobAd.properties,
                    idProperty: config.jobAd.idProperty,
                },
            }),
        };
    },
    created() {
        document.title = process.env.VUE_APP_TITLE;
    },
    computed: {
        scrollLock() {
            return this.$store.state.Chatbot.isOpen;
        },
    },
    methods: {
        enableTracking() {
            this.$matomo && this.$matomo.rememberConsentGiven();
        },
        closeChatbot() {
            const chatbotButton = document.querySelector(
                '.sticky-button-chatbot',
            );
            if (chatbotButton && !chatbotButton.contains(event.target)) {
                this.$store.commit(Chatbot.mutations.CLOSE_CHATBOT);
            }
        },
    },
};
</script>
<style scoped>
.scrollLock {
    @media (max-width: 960px) {
        position: fixed;
        overflow: hidden;
    }
}
</style>
